import './OverlayModal.css';
import { Overlay } from '@ipfabric/ui-components/Overlay/Overlay';

import classNames from 'classnames';
import type { FC } from 'react';
import type { ReactNode } from 'react';

type OverlayModalSize = 'small' | 'content-default';

interface Props {
  children: ReactNode;
  size?: OverlayModalSize;
  contentClassName?: string;
  onClose?: () => void;
}

export const OverlayModal: FC<Props> = (props) => (
  <Overlay onClose={props.onClose}>
    <div
      className={classNames(
        'overlay-modal',
        `overlay-modal--${props.size ?? 'small'}`,
        props.contentClassName,
      )}
    >
      {props.children}
    </div>
  </Overlay>
);
